import _ from "lodash";

export function number(value) {
    return _.floor(value, 2)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

export function date(value) {
    return value.length <= 10 ? value : value.substr(0, value.length - 3);
}

export function min(value) {
    return Math.floor(value / 60);
}
export function time(value) {
    return value.slice(0, 5);
}
export function capital(value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
export function hours(value) {
    const horas = Math.floor(value / 60);
    const min = value % 60;
    return `${horas}:${min.toString().padStart(2, "0")}`;
}

export function datePostShift(value) {
    let d = new Date(value.date + " " + value.shift_start);
    d.setTime(d.getTime() + parseInt(value.duration) * 60000);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Los meses comienzan en 0
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return  `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export function datePost(value) {
    let d = new Date(value.start_event_date);
    d.setTime(d.getTime() + parseInt(value.time_stop) * 60000);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Los meses comienzan en 0
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return  `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function AuthorizationFormat(value) {
    let words = value.split(" ");
    let initials= ''
    for (let i = 0; i < words.length; i++) 
        initials += words[i].charAt(0);
    return initials;
}

export function dateFormat(value) {
    const date = new Date(value);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Sumamos 1 porque los meses se indexan desde 0
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
}
